import _ from "lodash";
import {
  v4 as uuid,
} from "uuid";
import {
  inline,
} from "CommonState/action-helpers";

export function pushBreadcrumbLocation(breadcrumb, title) {
  return dispatch => {
    let key;
    dispatch(inline("breadcrumbs", state => {
      const b = state.breadcrumbs || (state.breadcrumbs = []);
      key = uuid();
      b[b.length] = { breadcrumb, title, key };
    }));
    return key;
  };
}

export function updateBreadcrumbLocation(breadcrumb, title, key) {
  return inline("breadcrumbs", state => {
    const b = state.breadcrumbs || (state.breadcrumbs = []);
    const i = _.findIndex(b, c => c.key === key);
    if (i !== -1) {
      b[i] = { breadcrumb, title, key };
    }
  });
}

export function popBreadcrumbLocation(key) {
  return inline("breadcrumbs", state => {
    const b = state.breadcrumbs || (state.breadcrumbs = []);
    const i = _.findIndex(b, c => c.key === key);
    b.splice(i, 1);
  });
}
